import React from 'react';
import { usePublicTypography } from '@/hooks/usePublicTypography';

export function FontLoader() {
  usePublicTypography();
  return null;
}